export default `import React from "react";
import {Media} from 'zapify-ui';

function Media(props) {
  return (
    <div>
    <Media typeGet="linear">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.</Media>
    </div>
  );
}
export default Box;`